module.exports = __webpack_public_path__ + "e8.no2.db29934b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/e8.no2.jpg
// module id = 8XG4
// module chunks = 0